<template>
  <div>
    <b-card class="col-12" no-body>
      <div class="m-2">
        <b-row>
          <b-col cols="12">
            <h4>
              Danh sách đơn hàng
              <a
                  v-b-tooltip.hover.top="'Lấy lại danh sách!'"
                  class="btn-icon"
                  @click="$router.go()"
              >
                <feather-icon icon="RepeatIcon"
                />
              </a>
            </h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="10">
            <b-tabs>
              <!--                            <b-tab-->
              <!--                                    v-for="f in flow"-->
              <!--                                    :active="selectedTab == f.ID"-->
              <!--                                    :key="f.ID"-->
              <!--                                    @click="changeTab(f)"-->
              <!--                                    :title="f.Name"-->
              <!--                            >-->
              <!--                            </b-tab>-->
            </b-tabs>
          </b-col>
          <b-col class="text-end mb-2" cols="2">
            <b-button v-if="!userRole.includes('TELESALE')" class="btn" variant="primary"
                      @click="$bvModal.show('activated-order-transfer')"> Điều
              chuyển đơn
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <vue-good-table
                :columns="fields"
                :isLoading.sync="isLoading"
                :line-numbers="true"
                :pagination-options="{
                                    perPage: serverParams.pageSize,
                                    enabled: true,
                                    dropdownAllowAll: true,
                                    allLabel: 'All',
                                    setCurrentPage: serverParams.page,
                                  }"
                :rows="tableData"
                :totalRows="totalRecords"
                mode="remote"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
            >
              <!-- <template slot="table-column" slot-scope="props">
                <span v-if="props.column.field =='username'">
                  {{props.column.label}}
                </span>
                <span v-else>
                 {{props.column.label}}
                </span>
              </template> -->
              <template slot="table-row" slot-scope="props">
                <!-- Column: Action -->
                <span v-if="props.column.field === 'action'">
                  <span class="action-col">
                    <b-button
                        class="btn-icon"
                        size="sm"
                        variant="primary"
                        @click="onShowDetailModal(props.row)"
                    >
                      <feather-icon icon="EyeIcon"/>
                    </b-button>
                  </span>
                </span>
                <span
                    v-else-if="
                    props.column.field === 'createdDate' ||
                    props.column.field === 'activatedDate' ||
                    props.column.field === 'CallDate'
                  "
                >
                  {{ getDateTime(props.formattedRow[props.column.field]) }}
                </span>
                <span v-else-if="props.column.field === 'Status'">
                  {{
                    status.find(
                        (item) =>
                            item.id == props.formattedRow[props.column.field]
                    ).text
                  }}
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-modal
        id="activated-order-transfer"
        body-class="modal-activated-order"
        size="lg"
        title="Điều chuyển đơn"
        @ok="transferOrder"
    >
      <p>Trạng thái</p>
      <select2 v-model="filterStatus" :options="filterStatusList" :settings="{minimumResultsForSearch:Infinity}"
               @change="getOrderTask(filterStatus)"/>
      <h4 class="mt-2">Điều chuyển từ</h4>
      <table class="table table-bordered table-striped table-sm mt-2">
        <thead>
        <th style="width:30px">STT</th>
        <th style="width:50%">User</th>
        <th>Số lượng</th>
        <th>Số lượng điều chuyển</th>
        </thead>
        <tbody>
        <tr>
          <td>{{ 1 }}</td>
          <td>
            Chưa phân bổ
          </td>
          <td>
            {{ orderTaskList.total[0].total }}
          </td>
          <td>
            <b-form-input v-model="transferOrderNumber"
                          :class=" orderTaskList.total[0].isErrTranfer? 'border-primary':''"
                          type="number"/>
          </td>
        </tr>
        <tr v-for="(i,index) in orderTaskList.data" :key="i.mail">
          <td>{{ index + 2 }}</td>
          <td>
            {{ i.KTV }}
          </td>
          <td>
            {{ i.number }}
          </td>
          <td>
            <b-form-input v-model="i.orderTranfer" :class="i.isErrTranfer? 'border-primary':''"
                          type="number"/>
          </td>
        </tr>
        </tbody>
      </table>
      <h4 class="mt-2">Điều chuyển đến</h4>
      <select2 v-model="orderReceivedMail" :options="orderTaskList.user"
               :settings="{minimumResultsForSearch:Infinity}"></select2>

    </b-modal>
    <b-modal
        id="activated-order-modal"
        :title="`Cuộc gọi tới số thuê bao ${
        selectedRecord ? selectedRecord.ContactNumber : ''
      } - ${selectedRecord ? selectedRecord.RefID : ''}`"
        body-class="modal-activated-order"
        hide-footer
        size="xl"
    >
      <b-button
          style="
          position: absolute;
          right: 4rem;
          top: 0;
          padding: 5px 5px;
          z-index: 1;
        "
          variant="danger"
          @click="$bvModal.show('popupCreateSimOrder')"
      >Tạo đơn sim
      </b-button
      >
      <validation-observer ref="modalView">
        <b-row>
          <b-col class="col-700-scroll" cols="4">
            <h5>Thông tin chung</h5>
            <b-card body-class="p-1" class="mb-1">
              <b-card-text>
                <b-row>
                  <b-col
                      v-for="(item, index) in detailColumnExtra"
                      :key="index"
                      cols="12"
                  >
                    <b-form-group :label="item.label">
                      <b-form-input
                          :value="
                          detailQuestionExtra.Detail
                            ? detailQuestionExtra.Detail[item.key]
                            : ''
                        "
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-text>
            </b-card>
            <b-card
                v-for="(table, index) in detailQuestionExtra.ExtraDataTable"
                :key="index"
                body-class="p-0"
                class="mb-1"
            >
              <b-card-text>
                <div class="history-call__header">
                  <h5>{{ table.TableName }}</h5>
                  <h5>{{ table.TableData.length }}</h5>
                </div>
                <b-table
                    :bordered="false"
                    :borderless="false"
                    :dark="false"
                    :fields="
                    table.TableColumn.map((item) => ({
                      key: Object.keys(item)[0],
                      label: item[Object.keys(item)[0]],
                    }))
                  "
                    :fixed="false"
                    :hover="false"
                    :items="table.TableData"
                    :no-border-collapse="false"
                    :outlined="false"
                    :small="false"
                    :striped="false"
                ></b-table>
              </b-card-text>
            </b-card>
          </b-col>
          <b-col class="col-700-scroll" cols="8">
            <h5>Thông tin kháo sát</h5>
            <b-card
                v-if="listOfConnection.length > 0"
                body-class="p-1"
                class="mb-1"
            >
              <b-card-text>
                <b-row>
                  <b-col cols="6">
                    <h5>Trạng thái kết nối</h5>
                    <template v-for="(s, i) in listOfConnection">
                      <b-form-group :key="i" :label="`Kết nối lần ${i+1}`">
                        <b-form-radio-group
                            v-model="s.callStatusSelected"
                            :disabled="s.disabledModalField"
                            :options="s.callStatus"
                            text-field="text"
                            value-field="id"
                            @change="onCallStatusSelectedConnection(s)"
                        ></b-form-radio-group>
                      </b-form-group>
                    </template>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group label="Ghi chú">
                      <v-select
                          v-model="detailQuestionExtra.Note"
                          :disabled="disabledModalField"
                          :options="listOfNote"
                          :reduce="option => option.text"
                          label="text"
                          rows="1"
                          size="sm"
                      ></v-select>
                      <b-form-textarea
                          v-if="detailQuestionExtra.Note=='Khác'"
                          v-model="detailQuestionExtra.writeNote"
                          :disabled="disabledModalField"
                          class="mt-1"
                          rows="1"
                          size="sm"
                      ></b-form-textarea>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-text>
            </b-card>
            <template v-if="callStatusSelected == 1">
              <b-card
                  v-for="(question, index) in detailQuestions"
                  :key="index"
                  body-class="p-1"
                  class="mb-1"
              >
                <b-card-text>
                  <b-row>
                    <b-col cols="12">
                      <validation-provider
                          #default="{ errors }"
                          :rules="question.required ? 'required' : ''"
                      >
                        <b-form-group :label="question.text">
                          <div v-if="question.note">
                            <div v-html="question.note"></div>
                          </div>
                          <b-form-radio-group
                              v-if="question.type == 'R'"
                              v-model="question.value"
                              :disabled="disabledModalField"
                              :options="question.options"
                              disabled-field="notEnabled"
                              text-field="text"
                              value-field="id"
                          ></b-form-radio-group>
                          <b-form-input
                              v-else-if="question.type == 'T'"
                              v-model="question.value"
                              :disabled="disabledModalField"
                              size="sm"
                          />
                          <b-form-input
                              v-else-if="question.type == 'N'"
                              v-model="question.value"
                              :disabled="disabledModalField"
                              number
                              size="sm"
                              type="number"
                          />
                          <b-form-checkbox-group
                              v-else-if="question.type == 'C'"
                              v-model="question.value"
                              :disabled="disabledModalField"
                              :options="question.options"
                              disabled-field="notEnabled"
                              text-field="text"
                              value-field="id"
                          ></b-form-checkbox-group>
                          <b-form-select
                              v-else-if="question.type == 'S'"
                              v-model="question.value"
                              :disabled="disabledModalField"
                              :options="question.options"
                          ></b-form-select>
                          <div class="error-txt">
                            <small v-if="errors.length > 0"
                            >Bạn không được để trống trường này</small
                            >
                          </div>
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col
                        v-if="question.type == 'R' && question.value == 0"
                        cols="12"
                    >
                      <b-form-textarea
                          v-model="question.subValue"
                          :disabled="disabledModalField"
                          rows="1"
                          size="sm"
                      ></b-form-textarea>
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-card>
            </template>
            <template v-if="callStatusSelected == 0">
              <b-card body-class="p-1" class="mb-1">
                <b-card-text>
                  <b-row>
                    <b-col cols="12">
                      <b-form-group label="Thời gian hẹn gọi lại">
                        <flat-pickr
                            v-model="appointmentTime"
                            :config="{
                            enableTime: true,
                            dateFormat: 'd-m-Y H:i',
                          }"
                            :disabled="disabledModalField"
                            class="form-control"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-card>
            </template>
            <div class="d-flex justify-content-end mb-2">
              <button class="btn btn-primary" type="button" @click="handleOk">
                OK
              </button>
            </div>
          </b-col>
        </b-row>
      </validation-observer>
    </b-modal>
    <PopupCreateOrder
        :modalSrc="$ctx.URL_FRONTEND + '/mua-hang?iframe=true&type=TeleSale'"
        modalId="popupCreateSimOrder"
        @onCreateOrderSuccess="loadItems()"
    />
    <!--        modalSrc="https://itel.dev/mua-hang?iframe=true&type=TeleSale"-->
  </div>
</template>
<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import vSelect from "vue-select";
import {VueGoodTable} from "vue-good-table";
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCardText,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
  BTooltip,
  VBTooltip,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import "@core/scss/vue/libs/vue-good-table.scss";
import Select2 from "v-select2-component";
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import Vue from "vue";
import VueExcelXlsx from "vue-excel-xlsx";
import {$ctx} from "@themeConfig";
import PopupCreateOrder from "@/views/b2c/PopupCreateOrder.vue";

Vue.use(VueExcelXlsx);

export default {
  components: {
    PopupCreateOrder,
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
    BTabs,
    BTab,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BFormTextarea,
    BCardText,
    BInputGroup,
    flatPickr,
  },

  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  async mounted() {
    await this.getOutBound();
    await this.getTabTableData();
    this.getOrderTask(0);
    window.addEventListener("message", this.handleMessageEventer, false);
    this.userRole = JSON.parse(localStorage.getItem('userData')).role
  },
  computed: {
    $ctx() {
      return $ctx
    },
    flowId() {
      return this.selectedTab;
    },
    disabledModalField() {
      return (
          this.selectedRecord &&
          (this.selectedRecord.Status === 2 || this.selectedRecord.Status === 3)
      );
    },
    exportExcelData() {
      let data = this.exportTableData || [];

      return data.map((el) => {
        return {
          ...el,
          Status: (this.status.find((o) => o.id == el.Status) || {text: ""})
              .text,
        };
      });
    },
  },
  watch: {
    callStatusSelected(newValue, oldValue) {
      // if(newValue == 0){
      //   this.appointmentTime = moment(new Date(), "DD-MM-YYYY HH:mm").add(1, 'days').format("DD-MM-YYYY HH:mm");
      // }
    },
  },
  methods: {
    handleMessageEventer(e) {
      let key = e.message ? "message" : "data";
      let data = e[key];

      if (typeof data == "object") {
        if (data?.type == "onReload") {
          this.loadItems();
        }

        if (data?.type == "onOrderSIM" || data?.type == "onOrderDEVICE") {
          this.loading(true);
          let payload = data.data;
          payload.obid = this.selectedRecord.ID
          if (
              payload.cart.find((el) => el.product_type && el.product_type != 100)
          ) {
            payload.transactionType = "DEVICE";
          }
          useJwt
              .post("create-order", payload)
              .then((response) => {
                this.loading(false);
                this.loadItems();
                if (data?.type == "onOrderSIM") {
                  document
                      .getElementById("iframepopupCreateSimOrder")
                      .contentWindow.postMessage(
                      {
                        type: "onOrderSIMSucess",
                        data: {id: response.data.result},
                      },
                      "*"
                  );
                }
                if (data?.type == "onOrderDEVICE") {
                  document
                      .getElementById("iframepopupCreateOrder")
                      .contentWindow.postMessage(
                      {
                        type: "onOrderSucess",
                        data: {id: response.data.result},
                      },
                      "*"
                  );
                }
              })
              .catch((error) => {
                if (data?.type == "onOrderSIM") {
                  document
                      .getElementById("iframepopupCreateSimOrder")
                      .contentWindow.postMessage(
                      {type: "onOrderSIMFail", data: {}},
                      "*"
                  );
                }
                if (data?.type == "onOrderDEVICE") {
                  document
                      .getElementById("iframepopupCreateOrder")
                      .contentWindow.postMessage(
                      {type: "onOrderFail", data: {}},
                      "*"
                  );
                }
                this.loading(false);
              });
        }
      }
    },
    loadItems() {
      this.loading(true);
      this.isLoading = true;
      let data = {
        ...this.serverParams,
        columnFilters: {
          ...(this.serverParams.columnFilters
              ? this.serverParams.columnFilters
              : []),
        },
      };
      if (data.columnFilters.CreateDate_ != undefined) {
        delete data.columnFilters["CreateDate_"];
      }
      useJwt
          .post("ghtk/order-list", data)
          .then((response) => {
            this.rows = response.data.result;
            //console.log(this.rows)
            this.totalRecords = response.data.totalRecords;
            this.rows.forEach((i) => {
              if (i.J_Shipment) {
                i.J_Shipment = JSON.parse(i.J_Shipment);
              }
            });
            this.isLoading = false;
            this.loading(false);
          })
          .catch((error) => {
            this.loading(false);
            this.isLoading = false;
          });
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      this.serverParams.sortBy = newProps['0']
      if (this.serverParams.columnFilters.Status == "") {
        delete this.serverParams.columnFilters.Status;
      }
    },
    async handleOk(bvModalEvt) {
      if (bvModalEvt) {
        bvModalEvt.preventDefault();
      }

      if (this.selectedRecord.Status === 2) {
        this.$bvModal.hide("activated-order-modal");
        return;
      }

      var validate = await this.$refs.modalView.validate().then((success) => {
        return success;
      });
      if (!validate) {
        this.$toast.warning("Vui lòng nhập các trường thông tin bắt buộc", {
          icon: true,
          closeButton: "button",
        });
        return;
      }

      this.callStatusSelected =
          this.listOfConnection.length > 0
              ? this.listOfConnection[this.listOfConnection.length - 1]
                  .callStatusSelected
              : 0;

      let data = {
        obid: this.selectedRecord.ID,
        // "appointmentTime": "",
        callStatus: this.callStatusSelected,
        note: this.detailQuestionExtra.Note,
        type: 2
        // "results": {}
      };
      if (data.note == 'Khác') {
        data.note = this.detailQuestionExtra.writeNote;
      }
      if (this.callStatusSelected == 0) {
        data.appointmentTime = this.appointmentTime;
      } else {
        data.results = {};
        this.detailQuestions.forEach((el) => {
          data.results[el.id] = el.value;
        });
      }
      useJwt
          .post("ob/submit", data)
          .then(async (response) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Cập nhật thành công!",
                icon: "CheckSquareIcon",
                variant: "success",
              },
            });
            await this.getTabTableData();
            this.$bvModal.hide("activated-order-modal");
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Lỗi cập nhật [" + error.response.data.result + "]!",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          });
    },
    // onSelectOrderType(val) {
    //   if (this.selectedTab != val) {
    //     this.selectedTab = val;
    //   }
    // },
    onSelectOrderTime(val) {
      if (this.selectedOrderTime != val) {
        this.selectedOrderTime = val;
      }
    },
    async onPageChange(params) {
      this.serverParams.page = params.currentPage;
      this.serverParams.currentPage = params.currentPage;
      await this.getTabTableData(true);
    },
    onSortChange(params) {
      this.updateParams(params);
      this.getTabTableData(false);
    },
    onColumnFilter(params) {
      this.updateParams(params);
      this.getTabTableData(false);
    },
    async onPerPageChange(params) {
      if (this.serverParams.pageSize !== params.currentPerPage) {
        this.serverParams.page = 1;
        this.serverParams.pageSize = params.currentPerPage;
        await this.getTabTableData(true);
      } else {
        setTimeout(() => {
          this.isLoading = false;
        }, 300);
      }
    },
    onConfirm1() {
    },
    onFailure1() {
    },
    onConfirm2() {
    },
    onFailure2() {
    },
    async onShowDetailModal(row) {
      this.appointmentTime = null;
      this.selectedRecord = JSON.parse(JSON.stringify(row));
      await this.getDetailData(row.ID);
      this.$bvModal.show("activated-order-modal");
    },
    async getOutBound() {
      const response = await useJwt.get("ob/meta");
      if (response.data.code == 200) {
        this.flow = [
          {ID: 0, GroupID: 1, Name: "Tất cả"},
          ...response.data.result.Flow,
        ];
        this.callStatus = response.data.result.CallStatus.reverse();
        this.group = response.data.result.Group;
        this.questionType = response.data.result.QuestionType;
        this.status = response.data.result.Status;
      } else {
        this.flow = [{ID: 0, GroupID: 1, Name: "Tất cả"}];
        this.callStatus = [];
        this.group = [];
        this.questionType = [];
        this.status = [];
      }
    },
    getFieldsTable(columns) {
      this.fields = columns.map((c) => {
        const key = Object.keys(c)[0];
        if (key === "Status") {
          return {
            field: key,
            filterOptions: {
              enabled: true,
              placeholder: "",
              filterDropdownItems: this.status.map((el) => {
                return {...el, value: el.id};
              }),
            },
            label: c[key],
            required: true,
            disabled: true,
            tdClass: "text-center",
          };
        } else {
          return {
            field: key,
            filterOptions: {enabled: true, placeholder: ""},
            label: c[key],
            required: true,
            disabled: true,
            tdClass: "text-center",
            width:
                key === "ID"
                    ? "50px"
                    : key === "ContactNumber"
                        ? "100px"
                        : key === "CallTimes"
                            ? "70px"
                            : "auto",
          };
        }
      });

      this.fields.push({
        field: "action",
        filterOptions: {enabled: false, placeholder: ""},
        label: "Action",
        required: true,
        disabled: true,
        width: "100px",
      });
    },
    async getTabTableData(isGetColumn = true) {
      const response = await useJwt.post(
          `ob/tasks/${this.groupId}/${this.flowId}`,
          this.serverParams
      );
      if (response.data.code == 200) {
        this.tableData = response.data.result ? response.data.result : [];
        this.totalRecords = response.data.totalRecords;
        if (isGetColumn) {
          this.getFieldsTable(response.data.extra.Column);
        }
      } else {
        if (isGetColumn) {
          this.getFieldsTable(response.data.extra.Column);
        }
        this.tableData = [];
        this.totalRecords = 0;
      }

      useJwt
          .post(`ob/tasks/${this.groupId}/${this.flowId}`, {
            ...this.serverParams,
            page: 0,
            pageSize: 0,
          })
          .then((rs) => {
            if (rs.data.code == 200) {
              this.exportTableData = rs.data.result ? rs.data.result : [];
            }
          });
    },
    async changeTab(e) {
      this.selectedTab = e.ID;
      this.groupId = e.GroupID;
      await this.getTabTableData();
    },
    getDateTime(e) {
      return moment(e).isValid() ? moment(e).format("DD/MM/YYYY HH:mm:ss") : "";
    },
    async getDetailData(id) {
      const response = await useJwt.get(`ob/detail/${id}`);
      if (response.data.code == 200) {
        const results = response.data.extra.Results || {};

        this.detailQuestions = response.data.result.map((el) => {
          return {
            ...el,
            value:
                this.selectedRecord.Status === 2 ||
                this.selectedRecord.Status === 3
                    ? results[el.id]
                    : null,
          };
        });
        this.detailQuestionExtra = response.data.extra;
        this.detailColumnExtra = response.data.extra.DetailColumn.map((el) => {
          let key = Object.keys(el)[0];
          let label = el[key];
          return {key, label};
        });

        if (response.data.extra.count.length > 0) {
          this.listOfConnection = response.data.extra.count.map((c) => {
            return {
              number: c.number,
              callStatus: this.callStatus,
              callStatusSelected: c.Status,
              disabledModalField: c.Status == 1 ? true : false,
            };
          });
          if (!this.listOfConnection[this.listOfConnection.length - 1].disabledModalField && this.listOfConnection.length < 3) {
            this.listOfConnection.push({
              number: this.listOfConnection.length,
              callStatus: this.callStatus,
              callStatusSelected: 0,
              disabledModalField: false,
            });
          }
        } else {
          this.listOfConnection = [
            {
              number: 0,
              callStatus: this.callStatus,
              callStatusSelected: 0,
              disabledModalField: false,
            },
          ];
        }

        this.callStatusSelected =
            this.listOfConnection.length > 0
                ? this.listOfConnection[this.listOfConnection.length - 1]
                    .callStatusSelected
                : 0;
      } else {
        this.listOfConnection = [];
        this.detailQuestions = [];
        this.detailQuestionExtra = {};
        this.detailColumnExtra = [];
      }
    },
    onCallStatusSelectedConnection: function (s) {
      this.callStatusSelected = s.callStatusSelected;
    },
    openTabCreateSimOrder: function () {
      window.open(`http://localhost:8000/mua-hang?iframe=true&type=TeleSale`, "_blank");
    },
    getOrderTask(status) {
      this.loading(true)
      useJwt.get('ob/order-task/' + status).then(res => {
        this.orderTaskList = res.data.result
        this.orderTaskList.user.forEach(e => {
          e.id = e.ID;
          e.text = e.ID
        })
        this.orderReceivedMail = this.orderTaskList.user[0].ID
        this.loading(false)
      }).catch(err => {
        console.log(err)
        this.loading(false)
      })
    },
    transferOrder(bvEvent) {
      let orderTransferList = []
      let isError = false;
      this.orderTaskList.data.forEach(e => {
        if (e.orderTranfer && e.orderTranfer != "") {
          if (parseInt(e.orderTranfer) > e.number) {
            e.isErrTranfer = true;
            isError = true;
          } else {
            orderTransferList.push({mail: e.KTV, value: parseInt(e.orderTranfer)})
          }

        }
      })
      if (parseInt(this.transferOrderNumber) > this.orderTaskList.total[0].total) {
        this.orderTaskList.total[0].isErrTranfer = true;
        isError = true;
      }
      if (isError) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Số lượng điều chuyển vượt quá số lượng cho phép!",
            icon: "XSquareIcon",
            variant: "danger",
          },
        });
        this.$forceUpdate();
        bvEvent.preventDefault();
        return;
      }
      useJwt.post('ob/order-transfer', {
        number: parseInt(this.transferOrderNumber),
        mail: this.orderReceivedMail,
        list: orderTransferList,
        status: parseInt(this.filterStatus)
      }).then(res => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Cập nhật thành công!",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
        this.getOrderTask(this.filterStatus)
      }).catch(err => {
        console.log(err)
      })
    }
  },
  data() {
    return {
      appointmentTime: null,
      callStatusSelected: 0,
      detailColumnExtra: [],
      selectedTab: 5,
      selectedOrderTime: 0,
      serverParams: {
        columnFilters: {},
        sort: [],
        page: 1,
        pageSize: 50,
      },
      totalRecords: 0,
      isLoading: false,
      flow: [],
      callStatus: [],
      group: [],
      groupId: 1,
      questionType: [],
      status: [],
      tableData: [],
      exportTableData: [],
      selectedRecord: null,
      detailQuestions: [],
      detailQuestionExtra: {},
      fields: [
        {
          field: "action",
          filterOptions: {enabled: false, placeholder: ""},
          label: "Action",
          required: true,
          disabled: true,
          width: "100px",
        },
      ],
      listOfConnection: [],
      tasks: [],
      filterStatusList: [
        {id: 0, text: 'Chờ xử lý'},
        {id: 1, text: 'Đang xử lý'},
        {id: 2, text: 'Hoàn thành'},
        {id: 3, text: 'Hủy'},

      ],
      filterStatus: 0,
      orderTaskList: [],
      orderReceivedMail: '',
      transferOrderNumber: 0,
      listOfNote: [
        {id: 1, text: "Tư vấn thành công nhưng KH tự đặt đơn"},
        {id: 2, text: "Tư vấn thành công nhưng KH đổi SĐT nhận hàng"},
        {id: 3, text: "SĐT đã có KH khác đặt"},
        {id: 4, text: "KH đã tự đặt lại đơn hàng trước khi KTV liên hệ"},
        {id: 5, text: "KH báo sẽ tự đặt lại sau"},
        {id: 6, text: " KTV đã đặt lại đơn cho KH"},
        {id: 7, text: "KH chưa có nhu cầu"},
        {id: 8, text: "KH suy nghĩ lại"},
        {id: 9, text: "KH đặt số khác"},
        {id: 10, text: "TB không nghe máy, KH từ chối nhận cuộc gọi, KH báo bận."},
        {id: 11, text: "Khác"}

      ],
      userRole: '',
    };
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.modal-activated-order {
  height: 700px;
  color: #000000;
}

.col-700-scroll {
  height: 680px;
  overflow: auto;
}
</style>
<style scoped>
.error-txt small {
  color: red;
}

.unselected {
  background: rgb(175, 175, 175) !important;
  border: rgb(175, 175, 175) !important;
}

.text-end {
  text-align: end;
}

.action-col {
  width: 100%;
  display: flex;
  justify-content: center;
}

.order-id:hover {
  cursor: pointer;
  font-weight: bold;
  color: rgb(34, 100, 243);
}

.detail-custom-table {
  width: 100%;
}

.detail-custom-table {
  display: inline-table;
  border: solid 1px rgb(207 207 207);
}

.detail-custom-table th,
.detail-custom-table td {
  border: solid 1px rgb(207 207 207);
  padding: 5px 10px;
}

.detail-custom-table th {
  vertical-align: baseline;
}

.history-call__header {
  display: flex;
  justify-content: space-between;
  padding: 20px;
}

.history-call__header h5 {
  margin: 0;
}

.note-question {
  font-style: italic;
  color: rgb(233, 71, 22);
  margin-bottom: 9px;
}
</style>
